import { IOffer } from '../types/offer';
import { prepareGallery } from './prepareGallery';
import { IOffers } from '../types/redux/offers';

export const prepareOffers = (offers: IOffer[] | null): IOffers => {
  const map: IOffers = {};
  if (!offers) {
    return map;
  }

  offers.forEach((offer: IOffer) => {
    offer.gallery = prepareGallery(offer);
    map[offer.id] = { ...offer };
  });

  return map;
};
